export const ABIERTO = 'A'
export const CERRADO = 'C'

export const __dictionary = {
  [ABIERTO]: {
    id: ABIERTO,
    nombre: 'ABIERTO'
  },
  [CERRADO]: {
    id: CERRADO,
    nombre: 'CERRADO'
  }
}

export const __array = [__dictionary[ABIERTO], __dictionary[CERRADO]]
